import React from "react";
import BlogBox from "./BlogBox";
import { MdOutlineTrendingUp } from "react-icons/md";

export default function AllBlogs() {
  return (
    <div>
      <h1 className="all-blog-page-title section-titles">Our Blog</h1>

      <div className="blog-bar blog-bar-container  mx-auto  px-3  py-2  ">
        <MdOutlineTrendingUp /> <h1>What's Trending</h1>
      </div>

      <div className="container mx-auto py-10 home-blog">
        <BlogBox
          category="Industry Connectivity"
          title="Why Traditional Networks Fall Short"
          imgSrc="https://meshmerize.net/wp-content/uploads/2023/08/connectivity-industry-4-1024x614.jpg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 27, 2025"
          link="/blog-single"
        />
        <BlogBox
          category="5G Technology"
          title="5 Real-World Applications of Private 4G/5G Networks"
          imgSrc="https://dgtlinfra.com/wp-content/uploads/2023/05/Examples-of-Private-5G-and-4G-LTE-Networks-Industrial-Internet-of-Things-IIoT.jpg.webp"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 28, 2025"
          link="/blog-single2"
        />
        <BlogBox
          category="Edge Computing"
          title="What is Edge Computing?"
          imgSrc="https://dnycf48t040dh.cloudfront.net/What-is-Edge-Computing.jpeg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 29, 2025"
          link="/blog-single3"
        />
      </div>

      <div className="blog-bar blog-bar-container  mx-auto  px-3  py-2  ">
        <MdOutlineTrendingUp /> <h1>Latest</h1>
      </div>

      <div className="container mx-auto py-10 home-blog">
        <BlogBox
          category="Enterprise Solutions"
          title="What is the FlexNet Marketplace"
          imgSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWuKonjjnKFDXkK5ryCO1B9SdkjpUcXH1w1A&s"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 30, 2025"
          link="/blog-single4"
        />
        <BlogBox
          category="Network Deployments"
          title="Quick-Deploy Networks"
          imgSrc="https://media.springernature.com/lw685/springer-static/image/chp%3A10.1007%2F978-3-030-89328-6_3/MediaObjects/501892_1_En_3_Fig2_HTML.png"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Jan 30, 2025"
          link="/blog-single5"
        />
        <BlogBox
          category="Partnerships"
          title="Business Partnerships"
          imgSrc="https://static.vecteezy.com/system/resources/previews/027/880/667/non_2x/partnership-concept-helps-the-team-to-find-solutions-and-win-together-successful-support-to-develop-new-ideas-work-together-or-collaborate-partner-team-help-support-each-other-to-success-vector.jpg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Feb 1, 2025"
          link="/blog-single6"
        />

        <BlogBox
          category="Portable Networks"
          title="Portable Connectivity"
          imgSrc="https://i.nextmedia.com.au/News/Telstra_MEOW.jpg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Feb 2, 2025"
          link="/blog-single7"
        />
        <BlogBox
          category="Security"
          title="Security First: How FlexNet Protects Your Data and Operations"
          imgSrc="https://media.licdn.com/dms/image/v2/C5112AQEF6dW_ZC4IMA/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1559990152625?e=2147483647&v=beta&t=5M62NAGshUD5zMW4z9b5ZNpCRUDVCZcnsHxUt_k5G9U"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Feb 3, 2025"
          link="/blog-single8"
        />
        <BlogBox
          category="Costs for Businesses"
          title=" How Private 5G Networks Reduce Costs for Businesses"
          imgSrc="https://s7d1.scene7.com/is/image/dmqualcommprod/privatenetworks_graphic"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Feb 5, 2025"
          link="/blog-single9"
        />
        <BlogBox
          category="Connectivity"
          title="Universal Connectivity"
          imgSrc="https://media-s3-us-east-1.ceros.com/commscope-inc/images/2019/10/28/4b526bfba3fd511156ac4155dc0a3c7c/mm-113889-en-cc-52314-update.jpg"
          authorImg="https://blocks.primereact.org/demo/images/blocks/avatars/circle/avatar-f-1.png"
          authorName="FlexNet Team"
          date="Feb 6, 2025"
          link="/blog-single10"
        />
      </div>
    </div>
  );
}
